import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyCHMJJYG7uvnwB2Z3Za69V5nNGsGYHqW9A",
  authDomain: "tiktok-clone-c9e1f.firebaseapp.com",
  databaseURL: "https://tiktok-clone-c9e1f.firebaseio.com",
  projectId: "tiktok-clone-c9e1f",
  storageBucket: "tiktok-clone-c9e1f.appspot.com",
  messagingSenderId: "1085380002441",
  appId: "1:1085380002441:web:516a76415c28dd48247c58"
};

const firebaseApp = 
firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;